/* eslint-disable consistent-return */
import { useEffect, useRef } from 'react';
import { sendBeacon } from '@ao-internal/digital-data';

export interface InViewProps {
	type: string;
	name: string;
	section: string;
}

export const useIntersectionObserver = (props: InViewProps) => {
	const ref = useRef<HTMLElement | null>(null);

	const { type, name, section } = props;

	useEffect(() => {
		if (!ref.current) return;

		const observer = new IntersectionObserver(
			(entries, observerInstance) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						sendBeacon(type, {
							name: name,
							section: section,
						});
						observerInstance.unobserve(entry.target);
					}
				});
			},
			{ threshold: 0 }
		);
		observer.observe(ref.current);

		return () => {
			observer.disconnect();
		};
	}, [type, name, section]);

	return ref;
};
